'use strict';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var EventEmitter = require('events');
var Connection = require('./connection');
var Pool = /** @class */ (function (_super) {
    __extends(Pool, _super);
    function Pool(opts) {
        var _this = _super.call(this, opts) || this;
        var options = __assign(__assign({ connectionLimit: 10, trace: true, busyTimeout: 30000 }, opts), { client: opts.client || 'sqlite3' });
        var client = require(options.client);
        // Turn on stack trace capturing otherwise the output is useless
        // - https://github.com/mapbox/node-sqlite3/wiki/Debugging
        if (options.trace)
            client.verbose();
        _this.options = options;
        _this.client = client;
        _this.connections = [];
        _this.queue = [];
        return _this;
    }
    Pool.prototype.getConnection = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, connections, queue, client, options, connections_1, connections_1_1, connection, connection;
            var e_1, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this, connections = _a.connections, queue = _a.queue, client = _a.client, options = _a.options;
                        try {
                            for (connections_1 = __values(connections), connections_1_1 = connections_1.next(); !connections_1_1.done; connections_1_1 = connections_1.next()) {
                                connection = connections_1_1.value;
                                if (connection.idle) {
                                    connection.idle = false;
                                    this.emit('acquire', connection);
                                    return [2 /*return*/, connection];
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (connections_1_1 && !connections_1_1.done && (_b = connections_1.return)) _b.call(connections_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        if (!(connections.length < options.connectionLimit)) return [3 /*break*/, 2];
                        connection = new Connection(__assign(__assign({}, options), { client: client, pool: this }));
                        connections.push(connection);
                        return [4 /*yield*/, this.emit('connection', connection)];
                    case 1:
                        _c.sent();
                        this.emit('acquire', connection);
                        return [2 /*return*/, connection];
                    case 2: return [4 /*yield*/, new Promise(function (resolve) { return queue.push(resolve); })];
                    case 3:
                        _c.sent();
                        return [4 /*yield*/, this.getConnection()];
                    case 4: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    Pool.prototype.releaseConnection = function (connection) {
        connection.idle = true;
        this.emit('release', connection);
        var queue = this.queue;
        while (queue.length > 0) {
            var task = queue.shift();
            task();
        }
    };
    Pool.prototype.end = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.allSettled(this.connections.map(function (connection) { return connection.close(); }))];
                    case 1:
                        _a.sent();
                        this.connections = [];
                        return [2 /*return*/];
                }
            });
        });
    };
    return Pool;
}(EventEmitter));
module.exports = Pool;
//# sourceMappingURL=pool.js.map